import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Module-level cache persists across component mounts/unmounts
let _previousPath = null;
let _currentPath = null;

/** Plain getter — reads cached paths without requiring Router context */
export const getNavigationHistory = () => ({
  currentPath: _currentPath,
  previousPath: _previousPath,
});

export const useNavigationHistory = () => {
  const location = useLocation();
  const previousPath = useRef(null);

  // Sync module-level cache before child components render
  if (_currentPath !== location.pathname) {
    previousPath.current = _currentPath;
    _previousPath = _currentPath;
    _currentPath = location.pathname;
  }

  useEffect(() => {
    previousPath.current = location.pathname;
  }, [location.pathname]);

  return {
    currentPath: location.pathname,
    previousPath: previousPath.current,
  };
};
